import React, { Fragment, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";
import { DEFAULT_IMAGE_SRC } from "@constants";
import { replaceErrorImage, showFailureToast } from "@helpers";
import styles from "./style/CoursePreviewCard.module.css";

const CoursePreviewCard = (props) => {
  const { imgPreview, videoPreview, isBestSeller, isProcessing } = props;
  const [showPreview, setShowPreview] = useState(false);

  const noImage =
    isProcessing || !imgPreview || (imgPreview ?? "string") === "string";
  const noVideo =
    isProcessing || !videoPreview || (videoPreview ?? "string") === "string";

  const imageUrl = noImage ? DEFAULT_IMAGE_SRC : imgPreview;

  return (
    <Fragment>
      <div
        className={clsx(
          styles.cardContainer,
          "placeholder-glow",
          noVideo && styles.cardNoPreview
        )}
        onClick={() => setShowPreview(true)}
      >
        <img
          src={imageUrl}
          className={styles.imgPreview}
          alt="course preview"
          onError={replaceErrorImage}
        />
        <div className={styles.courseOverlay}>
          {isBestSeller && <div className={styles.bestSeller}>Bestseller</div>}
          {!noVideo && (
            <>
              <span className={styles.playButton}>
                <i className="bi bi-play"></i>
              </span>
              <span className={styles.previewText}>Preview this course</span>
            </>
          )}
        </div>
      </div>

      {!noVideo && (
        <Modal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          dialogClassName={styles.modalVideo}
          contentClassName="border-0 bg-dark w-100 h-100"
          centered
          size="lg"
        >
          <ReactPlayer
            url={videoPreview || ""}
            light={imageUrl}
            controls={true}
            width="100%"
            onError={() => {
              showFailureToast("Can not play the preview");
            }}
            playing={true}
          />
        </Modal>
      )}
    </Fragment>
  );
};

/* required: display name */
CoursePreviewCard.displayName = "CoursePreviewCard";

/* required: props types */
CoursePreviewCard.propTypes = {
  imgPreview: PropTypes.string,
  isBestSeller: PropTypes.bool,
  onClick: PropTypes.func,
  isProcessing: PropTypes.bool,
};

/* required: default props */
CoursePreviewCard.defaultProps = {
  imgPreview: "",
  isBestSeller: false,
  onClick: () => {},
  isProcessing: false,
};

export { CoursePreviewCard };
